import { OUTLOOK_EN_INTRO, OUTLOOK_EN_SLUG } from '@/content/outlookEnergy'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The nineteenth report with a designed page of its own, and the tenth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the nine before it
  // (*"referans alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a
  // four-part full-page capture of the live page and all six of the images it
  // carries. See `content/outlookEnergy.ts` and `pages/OutlookEnergy.tsx`.
  ...outlook(
    OUTLOOK_EN_SLUG,
    'Energy & Utilities',
    undefined,
    'future-2030-outlook-energy-cover',
    'c4fc484a-53df-48de-9040-2618903c57e1-digitopia-future-2030-digital-transformation-outlook-energy.pdf',
  ),
  // The hero's one paragraph — same as the sibling outlook entries, and for the same
  // reason: this page draws its hero from `OUTLOOK_EN_INTRO` directly, so `body`
  // feeds exactly one thing, the meta description `prerender.tsx` takes from
  // `body[0]`. Unlike the nine siblings there is no bold claim to join to it, which
  // is the live page's own shape.
  body: [OUTLOOK_EN_INTRO.body[0]],
  layout: 'energy-outlook',
  // Its own words, its cover, its file and the six images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookEnergyChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 21
